import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import { rootSagas } from '../sagas'
import { deviceRtkApi } from '../rtk-query/devices'
import profile from '../reducers/profile'
import facility from '../reducers/facility'
import overview from '../reducers/overview'
import alerts from '../reducers/alerts'
import equipment from 'redux/reducers/equipments'
import devices from '../reducers/devices'
import notification from '../reducers/notification'
import confirmation from '../reducers/confirmationModal'
import redirectPageNotFound from '../reducers/isRedirectForPages'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer: {
    profile,
    facility,
    overview,
    alerts,
    equipment,
    devices,
    notification,
    confirmation,
    [deviceRtkApi.reducerPath]: deviceRtkApi.reducer,
    redirectPageNotFound,
  },
  devTools: process.env.REACT_APP_CUSTOM_NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: [
          'payload.callback',
          'payload.file',
          'payload.cb',
          'payload.arg',
          'payload.modalData.description',
          'meta.baseQueryMeta.request',
          'meta.baseQueryMeta.response',
        ],
      },
    }).concat(sagaMiddleware, deviceRtkApi.middleware),
})

sagaMiddleware.run(rootSagas)
